/*
 * Customer Reviews Split — Mobile arrow navigation
 */
(function () {
  'use strict';

  function initReviewsNav() {
    var sections = document.querySelectorAll('.cr-split');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var track = section.querySelector('#crReviewsTrack');
      var prevBtn = section.querySelector('#crPrev');
      var nextBtn = section.querySelector('#crNext');

      if (!track || !prevBtn || !nextBtn) return;

      function getScrollStep() {
        var card = track.querySelector('.cr-split__card');
        return card ? card.getBoundingClientRect().width + 14 : 280;
      }

      function scrollByCard(direction) {
        var step = getScrollStep();
        track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      prevBtn.replaceWith(prevBtn.cloneNode(true));
      nextBtn.replaceWith(nextBtn.cloneNode(true));

      var newPrevBtn = section.querySelector('#crPrev');
      var newNextBtn = section.querySelector('#crNext');

      newPrevBtn.addEventListener('click', function () { scrollByCard(-1); });
      newNextBtn.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsNav);
  } else {
    initReviewsNav();
  }

  document.addEventListener('shopify:section:load', initReviewsNav);
})();